import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getStores(params) {
  const response = await axiosClient.get(`/Stores${toQueryString(params)}`);
  return response.data;
}

export async function getMyStores() {
  const response = await axiosClient.get(`/Stores/mine`);
  return response.data;
}

export async function getStoreById(id) {
  const response = await axiosClient.get(`/Stores/${id}`);
  return response.data;
}

export async function updateStore(id, data) {
  const response = await axiosClient.put(`/Stores/${id}`, data);
  return response.data;
}

export async function uploadStoreLogo(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Stores/${id}/logo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function uploadStoreCoverImage(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Stores/${id}/cover-image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function getStoreCategories(id) {
  const response = await axiosClient.get(`/Stores/${id}/categories/public`);
  return response.data;
}

export async function getMyStoreCategories(id) {
  const response = await axiosClient.get(`/Stores/${id}/categories`);
  return response.data;
}

export async function addStoreCategory(id, categoryId, isPrimary = false) {
  const response = await axiosClient.post(`/Stores/${id}/categories`, { categoryId, isPrimary });
  return response.data;
}

export async function setPrimaryStoreCategory(id, categoryId) {
  const response = await axiosClient.put(`/Stores/${id}/categories/${categoryId}/primary`);
  return response.data;
}

export async function removeStoreCategory(id, categoryId) {
  await axiosClient.delete(`/Stores/${id}/categories/${categoryId}`);
}

export async function getStoreKeywords(id) {
  const response = await axiosClient.get(`/Stores/${id}/keywords`);
  return response.data;
}

export async function addStoreKeywords(id, keywords) {
  const response = await axiosClient.post(`/Stores/${id}/keywords`, { keywords });
  return response.data;
}

export async function deleteStoreKeyword(id, keywordId) {
  await axiosClient.delete(`/Stores/${id}/keywords/${keywordId}`);
}

export async function getStorefrontLayout(id) {
  const response = await axiosClient.get(`/Stores/${id}/storefront-layout`);
  return response.data;
}

export async function updateStorefrontLayout(id, items) {
  const response = await axiosClient.put(`/Stores/${id}/storefront-layout`, { items });
  return response.data;
}

export async function uploadStoreCarouselImage(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Stores/${id}/carousel/image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function uploadStoreCarouselVideo(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Stores/${id}/carousel/video`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function deleteStoreCarouselItem(id, itemId) {
  const response = await axiosClient.delete(`/Stores/${id}/carousel/${itemId}`);
  return response.data;
}

export async function getStoreFollowStatus(storeId) {
  const response = await axiosClient.get(`/StoreFollows/${storeId}/status`);
  return response.data;
}

export async function followStore(storeId) {
  const response = await axiosClient.post(`/StoreFollows`, { storeId });
  return response.data;
}

export async function unfollowStore(storeId) {
  await axiosClient.delete(`/StoreFollows/${storeId}`);
}

export async function fetchFollowedStores() {
  const response = await axiosClient.get("/StoreFollows");
  return response.data;
}

export async function fetchFollowedStoresCount() {
  const response = await axiosClient.get("/StoreFollows/count");
  return response.data;
}

export async function getStoreBellStatus(storeId) {
  const response = await axiosClient.get(`/StoreBells/${storeId}/status`);
  return response.data;
}

export async function setStoreBell(storeId) {
  const response = await axiosClient.post(`/StoreBells`, { storeId });
  return response.data;
}

export async function unsetStoreBell(storeId) {
  await axiosClient.delete(`/StoreBells/${storeId}`);
}

export async function fetchStoreBells() {
  const response = await axiosClient.get("/StoreBells");
  return response.data;
}

export async function fetchStoreBellsCount() {
  const response = await axiosClient.get("/StoreBells/count");
  return response.data;
}
